"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArray = void 0;
exports.isArray = (value) => Array.isArray(value);
//# sourceMappingURL=is-array.js.map